import newrelic from 'newrelic';
import bonnetFetchImport from '@bonnet/next/fetch';
import { get as _get, isEmpty } from '../utilities/common';
import { createErrorMarkerFallback, isErrorMarkerResponse } from '../utilities/circuitBreakerErrorMarker';

// @bonnet/next/fetch's own CJS build never sets `exports.__esModule = true`, so webpack's default-
// import interop (which only unwraps `.default` when that flag is present) hands back the whole
// module object instead of the bonnetFetch function itself - calling it then throws
// "TypeError: (intermediate value)(...) is not a function". Unwrap it defensively here so this
// works whether or not that interop actually fires.
const bonnetFetch = bonnetFetchImport.default || bonnetFetchImport;

const LSC_OWNER_ERROR_MARKER = '__lscOwnerError';
const LSC_OWNER_TIMEOUT_MS = 2000;

export default async function fetchLscOwner(dealerId, zipCode) {
    if (!dealerId) {
        return { status: 'notFound', owner: null };
    }

    try {
        const response = await bonnetFetch(`/rest/lsc/v1/owner/id/${encodeURIComponent(dealerId)}`, {
            search: { zip: zipCode },
            circuitBreaker: {
                timeout: LSC_OWNER_TIMEOUT_MS,
                fallback: createErrorMarkerFallback(LSC_OWNER_ERROR_MARKER),
                id: 'lsc_owner',
            },
        });

        if (response.status === 204) {
            return { status: 'notFound', owner: null };
        }

        let body;
        try {
            body = await response.json();
        } catch (parseError) {
            if (typeof window === 'undefined') {
                newrelic.noticeError(parseError, { dealerId, zipCode, breaker: 'lsc_owner', reason: 'unparseable_response' });
            }
            return { status: 'error', owner: null };
        }

        if (isErrorMarkerResponse(body, LSC_OWNER_ERROR_MARKER)) {
            return { status: 'error', owner: null };
        }

        const owner = _get(body, 'owners.0');
        if (isEmpty(owner)) {
            return { status: 'notFound', owner: null };
        }

        return { status: 'ok', owner };
    } catch (error) {
        if (typeof window === 'undefined') {
            newrelic.noticeError(error, { dealerId, zipCode, breaker: 'lsc_owner' });
        }
        return { status: 'error', owner: null };
    }
}
